import React from 'react';

export const Bubble = ({children}) =>{
    return(
        <div className='w-full rounded-xl xl:rounded-2xl 2xl:rounded-3xl px-4 xl:px-6 2xl:px-10 py-3 xl:py-5 2xl:py-8 bg-stone-200 dark:bg-stone-500'>
                {children}
        </div>
    )
}
